export default __webpack_public_path__ + "static/media/our-goal.3819bbfb.png";